import { Combobox, Option } from "@fluentui/react-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Consultant } from "../../interfaces/Consultant";
import { ApplicationState } from "../../store";
import { useEditorStyles } from "../Styles/Editor";

type ConsultantDropdownProps = {
    setConsultant: (consultant?: Consultant) => void;
    currentConsultant?: Consultant;
    ariaInvalid?: boolean;
};

export const ConsultantDropdown: React.FC<ConsultantDropdownProps> = ({ setConsultant, currentConsultant, ariaInvalid }) => {
    // Collection
    const consultantsRaw = useSelector<ApplicationState, Consultant[] | undefined>((state: ApplicationState) => state.consultantsState.consultants);
    const [consultants, setConsultants] = useState<Consultant[]>([]);
    // Filters
    const [Filter, setFilter] = React.useState<Consultant[]>([]);
    const [Search, setSearch] = React.useState<string | undefined>();
    // Other
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Initial load
    React.useEffect(() => {
        if (consultantsRaw !== undefined) {
            setConsultants(consultantsRaw.filter(c => c.isActive === true));
        }
    }, [consultantsRaw]);
    React.useEffect(() => {
        if (consultants !== undefined) {
            setFilter(consultants);
        }
    }, [consultants]);

    return <Combobox
        className={styles.fluid}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        freeform
        placeholder={t('SelectConsultant')}
        onChange={(event) => {
            if (consultants !== undefined) {
                const value = event.target.value.trim();
                const matches = consultants.filter(
                    (c) => (c.displayName !== null && c.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
                );
                setFilter(matches);
                if (value.length && matches.length < 1) {
                    setSearch(value);
                    setConsultant(undefined);
                } else if (value.length && matches.length === 1) {
                    setSearch(value);
                    setConsultant(matches[0]);
                } else {
                    setSearch(undefined);
                    setConsultant(undefined);
                }
            }
        }}
        onOptionSelect={(event, data) => {
            if (data.optionValue && consultants) {
                const matchingOption = consultants.find(c => c.consultantid === data.optionValue);
                if (matchingOption) {
                    setSearch(undefined);
                    if (matchingOption.consultantid !== currentConsultant?.consultantid) {
                        setConsultant(matchingOption);
                    }
                    setFilter(consultants);
                } else {
                    setSearch(data.optionText);
                }
            }
        }}
        defaultValue={currentConsultant && currentConsultant.displayName ? currentConsultant.displayName : undefined}
        defaultSelectedOptions={currentConsultant && currentConsultant.consultantid ? [currentConsultant.consultantid] : undefined}
        aria-invalid={ariaInvalid}
    >
        {Search ? (
            <Option key="freeform" text={Search}>
                Search for "{Search}"
            </Option>
        ) : null}
        {Filter.map((p) => (
            <Option key={p.consultantid} value={p.consultantid !== null ? p.consultantid : ""}>{p.displayName !== null ? p.displayName : "-- ? --"}</Option>
        ))}
    </Combobox>;
};